import { render, staticRenderFns } from "./EditReportBenchmarkForm.vue?vue&type=template&id=5437611e&scoped=true"
import script from "./EditReportBenchmarkForm.vue?vue&type=script&lang=ts"
export * from "./EditReportBenchmarkForm.vue?vue&type=script&lang=ts"
import style0 from "./EditReportBenchmarkForm.vue?vue&type=style&index=0&id=5437611e&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5437611e",
  null
  
)

export default component.exports